"use client";
import { useEffect, useState } from "react";
import { IconArrowUp } from "@tabler/icons-react";

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollUp = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={scrollUp}
      aria-label="Back to top"
      className="fixed bottom-6 right-6 z-[5000] flex h-12 w-12 items-center justify-center rounded-full border border-white/15 bg-neutral-950/90 text-white shadow-lg shadow-violet-500/20 backdrop-blur-md transition hover:border-violet-400/60 hover:bg-violet-600"
    >
      <IconArrowUp className="h-5 w-5" />
    </button>
  );
}
